// import {useState, useRef} from 'react'
// import {Link} from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Login from '../features/user/Login'
import { useEffect } from 'react'
import { removeNotificationMessage } from '../features/common/headerSlice'
import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
function ExternalPage(){
    const dispatch = useDispatch()
    const { newNotificationMessage, newNotificationStatus } = useSelector(state => state.header)
  
    useEffect(() => {
        if (newNotificationMessage !== "") {
          if (newNotificationStatus === 1) NotificationManager.success(newNotificationMessage, 'Success')
          if (newNotificationStatus === 0) NotificationManager.error(newNotificationMessage, 'Error')
          if (newNotificationStatus === 2) NotificationManager.info(newNotificationMessage, 'info')
          dispatch(removeNotificationMessage())
        }
        //eslint-disable-next-line
      }, [newNotificationMessage])

    return(
        <div className="">
                <Login />
                <NotificationContainer />
        </div>
    )
}

export default ExternalPage